import React, { useEffect, useState } from "react";
import { css } from "@emotion/css";

import { Row, Col, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { langaugeTanslatorAction } from "../../../store/action/admin/languageTranslatorActions";
import CloseCircleIcon from "../../../Theme/CustomIcons/Icons/Essetional/CloseCircleIcon";
import { themeCreateAction } from "../../../store/action/admin/themeActions";

const { Text, Title } = Typography;

const LangaugeSettingsPopup = ({ onClose, onLanguageChange }) => {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );

  const [language, setLanguage] = useState(themeDefault?.info?.language);
  const { translations } = getLanguageTranslatorList;
  useEffect(() => {
    setLanguage(
      getLanguageTranslatorList?.translations?.title ||
        themeDefault?.info?.language ||
        "en"
    );
  }, [themeDefault]);

  const handleLanguageChange = async (value, fullName) => {
    setLanguage(value);
    if (getLanguageTranslatorList?.translations?.title !== value) {
      await dispatch(langaugeTanslatorAction(value));
    }
    await dispatch(
      themeCreateAction({
        language: value,
      })
    );
    onLanguageChange(fullName);
    onClose(); // Close the Popover after selecting a language
  };
  const languageData = [
    { id: "en", key: "english", label: "English" },
    { id: "ar", key: "arabic", label: "عربي" },
  ];
  return (
    <div style={{ maxHeight: "400px", overflow: "hidden" }}>
      <Row>
        {languageData.map((lang) => (
          <Col
            span={24}
            key={lang.id}
            className={css`
              padding: 0px 15px !important;
              background-color: ${language === lang.id
                ? `${themeDefault?.info?.colorPrimary}33`
                : "transparent"};
              transition: background-color 0.3s ease-in-out;
              cursor: pointer;
              &:hover {
                background-color: ${themeDefault?.info?.colorPrimary}33;
              }
            `}
            onClick={() => handleLanguageChange(lang.id, lang.label)}
          >
            <Text
              style={{
                display: "block",
                padding: "5px",
              }}
            >
              {lang.label}
            </Text>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default LangaugeSettingsPopup;
